import { Spinner } from "./spinner";

interface LoadingOverlayProps {
  show: boolean;
}

export const LoadingOverlay = ({ show }: LoadingOverlayProps) => {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm"
      role="status"
      aria-live="polite"
    >
      <Spinner size={56} className="text-white" />
    </div>
  );
};
